import _toConsumableArray from "/vercel/path0/node_modules/react-scripts/node_modules/@babel/runtime/helpers/esm/toConsumableArray";
import _classCallCheck from "/vercel/path0/node_modules/react-scripts/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/vercel/path0/node_modules/react-scripts/node_modules/@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "/vercel/path0/node_modules/react-scripts/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _get from "/vercel/path0/node_modules/react-scripts/node_modules/@babel/runtime/helpers/esm/get";
import _getPrototypeOf from "/vercel/path0/node_modules/react-scripts/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "/vercel/path0/node_modules/react-scripts/node_modules/@babel/runtime/helpers/esm/inherits";
import _assertThisInitialized from "/vercel/path0/node_modules/react-scripts/node_modules/@babel/runtime/helpers/esm/assertThisInitialized";
import _asyncToGenerator from "/vercel/path0/node_modules/react-scripts/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import _defineProperty2 from "/vercel/path0/node_modules/react-scripts/node_modules/@babel/runtime/helpers/esm/defineProperty";

var _adapters, _adapters2;

function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return exports; }; var exports = {}, Op = Object.prototype, hasOwn = Op.hasOwnProperty, $Symbol = "function" == typeof Symbol ? Symbol : {}, iteratorSymbol = $Symbol.iterator || "@@iterator", asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator", toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag"; function define(obj, key, value) { return Object.defineProperty(obj, key, { value: value, enumerable: !0, configurable: !0, writable: !0 }), obj[key]; } try { define({}, ""); } catch (err) { define = function define(obj, key, value) { return obj[key] = value; }; } function wrap(innerFn, outerFn, self, tryLocsList) { var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator, generator = Object.create(protoGenerator.prototype), context = new Context(tryLocsList || []); return generator._invoke = function (innerFn, self, context) { var state = "suspendedStart"; return function (method, arg) { if ("executing" === state) throw new Error("Generator is already running"); if ("completed" === state) { if ("throw" === method) throw arg; return doneResult(); } for (context.method = method, context.arg = arg;;) { var delegate = context.delegate; if (delegate) { var delegateResult = maybeInvokeDelegate(delegate, context); if (delegateResult) { if (delegateResult === ContinueSentinel) continue; return delegateResult; } } if ("next" === context.method) context.sent = context._sent = context.arg;else if ("throw" === context.method) { if ("suspendedStart" === state) throw state = "completed", context.arg; context.dispatchException(context.arg); } else "return" === context.method && context.abrupt("return", context.arg); state = "executing"; var record = tryCatch(innerFn, self, context); if ("normal" === record.type) { if (state = context.done ? "completed" : "suspendedYield", record.arg === ContinueSentinel) continue; return { value: record.arg, done: context.done }; } "throw" === record.type && (state = "completed", context.method = "throw", context.arg = record.arg); } }; }(innerFn, self, context), generator; } function tryCatch(fn, obj, arg) { try { return { type: "normal", arg: fn.call(obj, arg) }; } catch (err) { return { type: "throw", arg: err }; } } exports.wrap = wrap; var ContinueSentinel = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var IteratorPrototype = {}; define(IteratorPrototype, iteratorSymbol, function () { return this; }); var getProto = Object.getPrototypeOf, NativeIteratorPrototype = getProto && getProto(getProto(values([]))); NativeIteratorPrototype && NativeIteratorPrototype !== Op && hasOwn.call(NativeIteratorPrototype, iteratorSymbol) && (IteratorPrototype = NativeIteratorPrototype); var Gp = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(IteratorPrototype); function defineIteratorMethods(prototype) { ["next", "throw", "return"].forEach(function (method) { define(prototype, method, function (arg) { return this._invoke(method, arg); }); }); } function AsyncIterator(generator, PromiseImpl) { function invoke(method, arg, resolve, reject) { var record = tryCatch(generator[method], generator, arg); if ("throw" !== record.type) { var result = record.arg, value = result.value; return value && "object" == typeof value && hasOwn.call(value, "__await") ? PromiseImpl.resolve(value.__await).then(function (value) { invoke("next", value, resolve, reject); }, function (err) { invoke("throw", err, resolve, reject); }) : PromiseImpl.resolve(value).then(function (unwrapped) { result.value = unwrapped, resolve(result); }, function (error) { return invoke("throw", error, resolve, reject); }); } reject(record.arg); } var previousPromise; this._invoke = function (method, arg) { function callInvokeWithMethodAndArg() { return new PromiseImpl(function (resolve, reject) { invoke(method, arg, resolve, reject); }); } return previousPromise = previousPromise ? previousPromise.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); }; } function maybeInvokeDelegate(delegate, context) { var method = delegate.iterator[context.method]; if (undefined === method) { if (context.delegate = null, "throw" === context.method) { if (delegate.iterator.return && (context.method = "return", context.arg = undefined, maybeInvokeDelegate(delegate, context), "throw" === context.method)) return ContinueSentinel; context.method = "throw", context.arg = new TypeError("The iterator does not provide a 'throw' method"); } return ContinueSentinel; } var record = tryCatch(method, delegate.iterator, context.arg); if ("throw" === record.type) return context.method = "throw", context.arg = record.arg, context.delegate = null, ContinueSentinel; var info = record.arg; return info ? info.done ? (context[delegate.resultName] = info.value, context.next = delegate.nextLoc, "return" !== context.method && (context.method = "next", context.arg = undefined), context.delegate = null, ContinueSentinel) : info : (context.method = "throw", context.arg = new TypeError("iterator result is not an object"), context.delegate = null, ContinueSentinel); } function pushTryEntry(locs) { var entry = { tryLoc: locs[0] }; 1 in locs && (entry.catchLoc = locs[1]), 2 in locs && (entry.finallyLoc = locs[2], entry.afterLoc = locs[3]), this.tryEntries.push(entry); } function resetTryEntry(entry) { var record = entry.completion || {}; record.type = "normal", delete record.arg, entry.completion = record; } function Context(tryLocsList) { this.tryEntries = [{ tryLoc: "root" }], tryLocsList.forEach(pushTryEntry, this), this.reset(!0); } function values(iterable) { if (iterable) { var iteratorMethod = iterable[iteratorSymbol]; if (iteratorMethod) return iteratorMethod.call(iterable); if ("function" == typeof iterable.next) return iterable; if (!isNaN(iterable.length)) { var i = -1, next = function next() { for (; ++i < iterable.length;) { if (hasOwn.call(iterable, i)) return next.value = iterable[i], next.done = !1, next; } return next.value = undefined, next.done = !0, next; }; return next.next = next; } } return { next: doneResult }; } function doneResult() { return { value: undefined, done: !0 }; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, define(Gp, "constructor", GeneratorFunctionPrototype), define(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, toStringTagSymbol, "GeneratorFunction"), exports.isGeneratorFunction = function (genFun) { var ctor = "function" == typeof genFun && genFun.constructor; return !!ctor && (ctor === GeneratorFunction || "GeneratorFunction" === (ctor.displayName || ctor.name)); }, exports.mark = function (genFun) { return Object.setPrototypeOf ? Object.setPrototypeOf(genFun, GeneratorFunctionPrototype) : (genFun.__proto__ = GeneratorFunctionPrototype, define(genFun, toStringTagSymbol, "GeneratorFunction")), genFun.prototype = Object.create(Gp), genFun; }, exports.awrap = function (arg) { return { __await: arg }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, asyncIteratorSymbol, function () { return this; }), exports.AsyncIterator = AsyncIterator, exports.async = function (innerFn, outerFn, self, tryLocsList, PromiseImpl) { void 0 === PromiseImpl && (PromiseImpl = Promise); var iter = new AsyncIterator(wrap(innerFn, outerFn, self, tryLocsList), PromiseImpl); return exports.isGeneratorFunction(outerFn) ? iter : iter.next().then(function (result) { return result.done ? result.value : iter.next(); }); }, defineIteratorMethods(Gp), define(Gp, toStringTagSymbol, "Generator"), define(Gp, iteratorSymbol, function () { return this; }), define(Gp, "toString", function () { return "[object Generator]"; }), exports.keys = function (object) { var keys = []; for (var key in object) { keys.push(key); } return keys.reverse(), function next() { for (; keys.length;) { var key = keys.pop(); if (key in object) return next.value = key, next.done = !1, next; } return next.done = !0, next; }; }, exports.values = values, Context.prototype = { constructor: Context, reset: function reset(skipTempReset) { if (this.prev = 0, this.next = 0, this.sent = this._sent = undefined, this.done = !1, this.delegate = null, this.method = "next", this.arg = undefined, this.tryEntries.forEach(resetTryEntry), !skipTempReset) for (var name in this) { "t" === name.charAt(0) && hasOwn.call(this, name) && !isNaN(+name.slice(1)) && (this[name] = undefined); } }, stop: function stop() { this.done = !0; var rootRecord = this.tryEntries[0].completion; if ("throw" === rootRecord.type) throw rootRecord.arg; return this.rval; }, dispatchException: function dispatchException(exception) { if (this.done) throw exception; var context = this; function handle(loc, caught) { return record.type = "throw", record.arg = exception, context.next = loc, caught && (context.method = "next", context.arg = undefined), !!caught; } for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i], record = entry.completion; if ("root" === entry.tryLoc) return handle("end"); if (entry.tryLoc <= this.prev) { var hasCatch = hasOwn.call(entry, "catchLoc"), hasFinally = hasOwn.call(entry, "finallyLoc"); if (hasCatch && hasFinally) { if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0); if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc); } else if (hasCatch) { if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0); } else { if (!hasFinally) throw new Error("try statement without catch or finally"); if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc); } } } }, abrupt: function abrupt(type, arg) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.tryLoc <= this.prev && hasOwn.call(entry, "finallyLoc") && this.prev < entry.finallyLoc) { var finallyEntry = entry; break; } } finallyEntry && ("break" === type || "continue" === type) && finallyEntry.tryLoc <= arg && arg <= finallyEntry.finallyLoc && (finallyEntry = null); var record = finallyEntry ? finallyEntry.completion : {}; return record.type = type, record.arg = arg, finallyEntry ? (this.method = "next", this.next = finallyEntry.finallyLoc, ContinueSentinel) : this.complete(record); }, complete: function complete(record, afterLoc) { if ("throw" === record.type) throw record.arg; return "break" === record.type || "continue" === record.type ? this.next = record.arg : "return" === record.type ? (this.rval = this.arg = record.arg, this.method = "return", this.next = "end") : "normal" === record.type && afterLoc && (this.next = afterLoc), ContinueSentinel; }, finish: function finish(finallyLoc) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.finallyLoc === finallyLoc) return this.complete(entry.completion, entry.afterLoc), resetTryEntry(entry), ContinueSentinel; } }, catch: function _catch(tryLoc) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.tryLoc === tryLoc) { var record = entry.completion; if ("throw" === record.type) { var thrown = record.arg; resetTryEntry(entry); } return thrown; } } throw new Error("illegal catch attempt"); }, delegateYield: function delegateYield(iterable, resultName, nextLoc) { return this.delegate = { iterator: values(iterable), resultName: resultName, nextLoc: nextLoc }, "next" === this.method && (this.arg = undefined), ContinueSentinel; } }, exports; }

import { CHAIN_NAMESPACES, SOLANA_ADAPTERS, EVM_ADAPTERS, getChainConfig, WALLET_ADAPTERS, log, ADAPTER_CATEGORY, ADAPTER_STATUS, ADAPTER_EVENTS } from '@web3auth/base';
import _defineProperty from '@babel/runtime/helpers/defineProperty';
import { Web3AuthCore } from '@web3auth/core';
import LoginModal, { getAdapterSocialLogins, OPENLOGIN_PROVIDERS, LOGIN_MODAL_EVENTS } from '@web3auth/ui';
var defaultSolanaDappModalConfig = {
  chainNamespace: CHAIN_NAMESPACES.SOLANA,
  adapters: (_adapters = {}, _defineProperty2(_adapters, SOLANA_ADAPTERS.TORUS_SOLANA, {
    label: "Torus Wallet",
    showOnModal: true,
    showOnMobile: true,
    showOnDesktop: true
  }), _defineProperty2(_adapters, SOLANA_ADAPTERS.OPENLOGIN, {
    label: "OpenLogin",
    showOnModal: true,
    showOnMobile: true,
    showOnDesktop: true
  }), _defineProperty2(_adapters, SOLANA_ADAPTERS.PHANTOM, {
    label: "Phantom",
    showOnModal: true,
    showOnMobile: true,
    showOnDesktop: true
  }), _adapters)
};
var defaultEvmDappModalConfig = {
  chainNamespace: CHAIN_NAMESPACES.EIP155,
  adapters: (_adapters2 = {}, _defineProperty2(_adapters2, EVM_ADAPTERS.TORUS_EVM, {
    label: "Torus Wallet",
    showOnModal: true,
    showOnMobile: true,
    showOnDesktop: true
  }), _defineProperty2(_adapters2, EVM_ADAPTERS.METAMASK, {
    label: "MetaMask",
    showOnModal: true,
    showOnMobile: true,
    showOnDesktop: true
  }), _defineProperty2(_adapters2, EVM_ADAPTERS.OPENLOGIN, {
    label: "OpenLogin",
    showOnModal: true,
    showOnMobile: true,
    showOnDesktop: true
  }), _defineProperty2(_adapters2, EVM_ADAPTERS.WALLET_CONNECT_V1, {
    label: "Wallet Connect",
    showOnModal: true,
    showOnMobile: true,
    showOnDesktop: true
  }), _adapters2)
};
var defaultSolanaWalletModalConfig = {
  chainNamespace: CHAIN_NAMESPACES.SOLANA,
  adapters: _defineProperty2({}, SOLANA_ADAPTERS.OPENLOGIN, {
    label: "OpenLogin",
    showOnModal: true,
    showOnMobile: true,
    showOnDesktop: true
  })
};
var defaultEvmWalletModalConfig = {
  chainNamespace: CHAIN_NAMESPACES.EIP155,
  adapters: _defineProperty2({}, EVM_ADAPTERS.OPENLOGIN, {
    label: "OpenLogin",
    showOnModal: true,
    showOnMobile: true,
    showOnDesktop: true
  })
};
var defaultOtherModalConfig = {
  chainNamespace: CHAIN_NAMESPACES.OTHER,
  adapters: _defineProperty2({}, EVM_ADAPTERS.OPENLOGIN, {
    label: "OpenLogin",
    showOnModal: true,
    showOnMobile: true,
    showOnDesktop: true
  })
};

function ownKeys$1(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread$1(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys$1(Object(source), !0).forEach(function (key) {
      _defineProperty(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys$1(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }

  return target;
}

var getDefaultAdapterModule = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(params) {
    var name, customChainConfig, clientId, finalChainConfig, _yield$import, TorusWalletAdapter, adapter, _yield$import2, SolanaWalletAdapter, _adapter, _yield$import3, MetamaskAdapter, _adapter2, _yield$import4, PhantomAdapter, _adapter3, _yield$import5, WalletConnectV1Adapter, _adapter4, _yield$import6, OpenloginAdapter, getOpenloginDefaultOptions, defaultOptions, _adapter5;

    return _regeneratorRuntime().wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            name = params.name, customChainConfig = params.customChainConfig, clientId = params.clientId;

            if (Object.values(CHAIN_NAMESPACES).includes(customChainConfig.chainNamespace)) {
              _context.next = 3;
              break;
            }

            throw new Error("Invalid chainNamespace: ".concat(customChainConfig.chainNamespace));

          case 3:
            finalChainConfig = _objectSpread$1(_objectSpread$1({}, getChainConfig(customChainConfig.chainNamespace, customChainConfig === null || customChainConfig === void 0 ? void 0 : customChainConfig.chainId)), customChainConfig || {});

            if (!(name === WALLET_ADAPTERS.TORUS_EVM)) {
              _context.next = 13;
              break;
            }

            _context.next = 7;
            return import('@web3auth/torus-evm-adapter');

          case 7:
            _yield$import = _context.sent;
            TorusWalletAdapter = _yield$import.TorusWalletAdapter;
            adapter = new TorusWalletAdapter({
              chainConfig: finalChainConfig
            });
            return _context.abrupt("return", adapter);

          case 13:
            if (!(name === WALLET_ADAPTERS.TORUS_SOLANA)) {
              _context.next = 22;
              break;
            }

            _context.next = 16;
            return import('@web3auth/torus-solana-adapter');

          case 16:
            _yield$import2 = _context.sent;
            SolanaWalletAdapter = _yield$import2.SolanaWalletAdapter;
            _adapter = new SolanaWalletAdapter({
              chainConfig: finalChainConfig
            });
            return _context.abrupt("return", _adapter);

          case 22:
            if (!(name === WALLET_ADAPTERS.METAMASK)) {
              _context.next = 31;
              break;
            }

            _context.next = 25;
            return import('@web3auth/metamask-adapter');

          case 25:
            _yield$import3 = _context.sent;
            MetamaskAdapter = _yield$import3.MetamaskAdapter;
            _adapter2 = new MetamaskAdapter({
              chainConfig: finalChainConfig
            });
            return _context.abrupt("return", _adapter2);

          case 31:
            if (!(name === WALLET_ADAPTERS.PHANTOM)) {
              _context.next = 40;
              break;
            }

            _context.next = 34;
            return import('@web3auth/phantom-adapter');

          case 34:
            _yield$import4 = _context.sent;
            PhantomAdapter = _yield$import4.PhantomAdapter;
            _adapter3 = new PhantomAdapter({
              chainConfig: finalChainConfig
            });
            return _context.abrupt("return", _adapter3);

          case 40:
            if (!(name === WALLET_ADAPTERS.WALLET_CONNECT_V1)) {
              _context.next = 49;
              break;
            }

            _context.next = 43;
            return import('@web3auth/wallet-connect-v1-adapter');

          case 43:
            _yield$import5 = _context.sent;
            WalletConnectV1Adapter = _yield$import5.WalletConnectV1Adapter;
            _adapter4 = new WalletConnectV1Adapter({
              chainConfig: finalChainConfig
            });
            return _context.abrupt("return", _adapter4);

          case 49:
            if (!(name === WALLET_ADAPTERS.OPENLOGIN)) {
              _context.next = 58;
              break;
            }

            _context.next = 52;
            return import('@web3auth/openlogin-adapter');

          case 52:
            _yield$import6 = _context.sent;
            OpenloginAdapter = _yield$import6.OpenloginAdapter;
            getOpenloginDefaultOptions = _yield$import6.getOpenloginDefaultOptions;
            defaultOptions = getOpenloginDefaultOptions(customChainConfig.chainNamespace, customChainConfig === null || customChainConfig === void 0 ? void 0 : customChainConfig.chainId);
            _adapter5 = new OpenloginAdapter(_objectSpread$1(_objectSpread$1({}, defaultOptions), {}, {
              chainConfig: _objectSpread$1(_objectSpread$1({}, defaultOptions.chainConfig || {}), finalChainConfig),
              adapterSettings: _objectSpread$1(_objectSpread$1({}, defaultOptions.adapterSettings), {}, {
                clientId: clientId
              })
            }));
            return _context.abrupt("return", _adapter5);

          case 58:
            throw new Error("Invalid wallet adapter name");

          case 59:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));

  return function getDefaultAdapterModule(_x) {
    return _ref.apply(this, arguments);
  };
}();

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      _defineProperty(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }

  return target;
}

var Web3Auth = /*#__PURE__*/function (_Web3AuthCore) {
  _inherits(Web3Auth, _Web3AuthCore);

  function Web3Auth(options) {
    var _this;

    _classCallCheck(this, Web3Auth);

    var _this$options$uiConfi, _this$options$uiConfi2;

    _this = _possibleConstructorReturn(this, _getPrototypeOf(Web3Auth).call(this, options));

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "loginModal", void 0);

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "options", void 0);

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "modalConfig", defaultEvmDappModalConfig);

    _this.options = _objectSpread({}, options);
    var providedChainConfig = _this.options.chainConfig;

    if (providedChainConfig.chainNamespace === CHAIN_NAMESPACES.SOLANA) {
      if (options.authMode === "WALLET") {
        // default config for solana wallet modal
        _this.modalConfig = defaultSolanaWalletModalConfig;
      } else {
        // default config for solana dapp modal
        _this.modalConfig = defaultSolanaDappModalConfig;
      }
    } else if (providedChainConfig.chainNamespace === CHAIN_NAMESPACES.EIP155) {
      if (options.authMode === "WALLET") {
        // default config for evm wallet modal
        _this.modalConfig = defaultEvmWalletModalConfig;
      } else {
        // default config for evm dapp modal
        _this.modalConfig = defaultEvmDappModalConfig;
      }
    } else if (providedChainConfig.chainNamespace === CHAIN_NAMESPACES.OTHER) {
      _this.modalConfig = defaultOtherModalConfig;
    } else {
      throw new Error("Invalid chainNamespace provided: ".concat(providedChainConfig.chainNamespace));
    }

    _this.loginModal = new LoginModal({
      theme: (_this$options$uiConfi = _this.options.uiConfig) === null || _this$options$uiConfi === void 0 ? void 0 : _this$options$uiConfi.theme,
      appLogo: ((_this$options$uiConfi2 = _this.options.uiConfig) === null || _this$options$uiConfi2 === void 0 ? void 0 : _this$options$uiConfi2.appLogo) || "",
      version: "",
      adapterListener: _assertThisInitialized(_assertThisInitialized(_this)),
      displayErrorsOnModal: _this.options.displayErrorsOnModal
    });

    _this.subscribeToLoginModalEvents();

    return _this;
  }

  _createClass(Web3Auth, [{
    key: "initModal",
    value: function () {
      var _initModal = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee4(params) {
        var _this2 = this;

        var providedChainConfig, allAdapters, adapterConfigurationPromises, adapterNames, hasInAppWallets, initPromises, hasExternalWallets;
        return _regeneratorRuntime().wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                _get(_getPrototypeOf(Web3Auth.prototype), "checkInitRequirements", this).call(this);

                _context4.next = 3;
                return this.loginModal.initModal();

              case 3:
                providedChainConfig = this.options.chainConfig; // merge default adapters with the custom configured adapters.

                allAdapters = _toConsumableArray(new Set([].concat(_toConsumableArray(Object.keys(this.modalConfig.adapters || {})), _toConsumableArray(Object.keys(this.walletAdapters)))));
                adapterConfigurationPromises = allAdapters.map( /*#__PURE__*/function () {
                  var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2(adapterName) {
                    var _this$modalConfig$ada, _params$modalConfig, _this$modalConfig$ada2, _this$modalConfig$ada3, adapterConfig, adapter, ad, _this$modalConfig$ada4, _this$coreOptions$cha, chainConfig;

                    return _regeneratorRuntime().wrap(function _callee2$(_context2) {
                      while (1) {
                        switch (_context2.prev = _context2.next) {
                          case 0:
                            // start with the default config of adapter.
                            adapterConfig = ((_this$modalConfig$ada = _this2.modalConfig.adapters) === null || _this$modalConfig$ada === void 0 ? void 0 : _this$modalConfig$ada[adapterName]) || {
                              label: adapterName,
                              showOnModal: true,
                              showOnMobile: true,
                              showOnDesktop: true
                            }; // override the default config of adapter if some config is being provided by the user.

                            if (params !== null && params !== void 0 && (_params$modalConfig = params.modalConfig) !== null && _params$modalConfig !== void 0 && _params$modalConfig[adapterName]) {
                              adapterConfig = _objectSpread(_objectSpread({}, adapterConfig), params.modalConfig[adapterName]);
                            }

                            _this2.modalConfig.adapters[adapterName] = adapterConfig; // check if adapter is configured/added by user and exist in walletAdapters map.

                            adapter = _this2.walletAdapters[adapterName];
                            log.debug("adapter config", adapterName, (_this$modalConfig$ada2 = _this2.modalConfig.adapters) === null || _this$modalConfig$ada2 === void 0 ? void 0 : _this$modalConfig$ada2[adapterName].showOnModal, adapter); // if adapter is not custom configured then check if it is available in default adapters.
                            // and if adapter is not hidden by user

                            if (!(!adapter && (_this$modalConfig$ada3 = _this2.modalConfig.adapters) !== null && _this$modalConfig$ada3 !== void 0 && _this$modalConfig$ada3[adapterName].showOnModal)) {
                              _context2.next = 13;
                              break;
                            }

                            _context2.next = 8;
                            return getDefaultAdapterModule({
                              name: adapterName,
                              customChainConfig: _this2.options.chainConfig,
                              clientId: _this2.options.clientId
                            });

                          case 8:
                            ad = _context2.sent;
                            _this2.walletAdapters[adapterName] = ad;
                            return _context2.abrupt("return", adapterName);

                          case 13:
                            if (!((adapter === null || adapter === void 0 ? void 0 : adapter.type) === ADAPTER_CATEGORY.IN_APP || (adapter === null || adapter === void 0 ? void 0 : adapter.type) === ADAPTER_CATEGORY.EXTERNAL || adapterName === _this2.cachedAdapter)) {
                              _context2.next = 19;
                              break;
                            }

                            if ((_this$modalConfig$ada4 = _this2.modalConfig.adapters) !== null && _this$modalConfig$ada4 !== void 0 && _this$modalConfig$ada4[adapterName].showOnModal) {
                              _context2.next = 16;
                              break;
                            }

                            return _context2.abrupt("return");

                          case 16:
                            // add client id to openlogin adapter, same web3auth client id can be used in openlogin.
                            // this id is being overridden if user is also passing client id in openlogin's adapter constructor.
                            if (adapterName === WALLET_ADAPTERS.OPENLOGIN) {
                              _this2.walletAdapters[adapterName].setAdapterSettings({
                                clientId: _this2.options.clientId
                              });
                            } // if adapter doesn't have any chainConfig then we will set the chainConfig based of passed chainNamespace
                            // and chainNamespace.


                            if (!adapter.chainConfigProxy) {
                              chainConfig = _objectSpread(_objectSpread({}, getChainConfig(providedChainConfig.chainNamespace, (_this$coreOptions$cha = _this2.coreOptions.chainConfig) === null || _this$coreOptions$cha === void 0 ? void 0 : _this$coreOptions$cha.chainId)), _this2.coreOptions.chainConfig);

                              _this2.walletAdapters[adapterName].setChainConfig(chainConfig);
                            }

                            return _context2.abrupt("return", adapterName);

                          case 19:
                          case "end":
                            return _context2.stop();
                        }
                      }
                    }, _callee2);
                  }));

                  return function (_x3) {
                    return _ref2.apply(this, arguments);
                  };
                }());
                _context4.next = 8;
                return Promise.all(adapterConfigurationPromises);

              case 8:
                adapterNames = _context4.sent;
                hasInAppWallets = Object.values(this.walletAdapters).some(function (adapter) {
                  var _this$modalConfig$ada5;

                  if (adapter.type !== ADAPTER_CATEGORY.IN_APP) return false;
                  if (_this2.modalConfig.adapters[adapter.name].showOnModal !== true) return false;
                  if (!_this2.modalConfig.adapters[adapter.name].loginMethods) return true;
                  var mergedLoginMethods = getAdapterSocialLogins(adapter.name, _this2.walletAdapters[adapter.name], (_this$modalConfig$ada5 = _this2.modalConfig.adapters[adapter.name]) === null || _this$modalConfig$ada5 === void 0 ? void 0 : _this$modalConfig$ada5.loginMethods);
                  if (Object.values(mergedLoginMethods).some(function (method) {
                    return method.showOnModal;
                  })) return true;
                  return false;
                });
                log.debug(hasInAppWallets, this.walletAdapters, "hasInAppWallets"); // Now, initialize the adapters.

                initPromises = adapterNames.map( /*#__PURE__*/function () {
                  var _ref3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee3(adapterName) {
                    var adapter;
                    return _regeneratorRuntime().wrap(function _callee3$(_context3) {
                      while (1) {
                        switch (_context3.prev = _context3.next) {
                          case 0:
                            if (adapterName) {
                              _context3.next = 2;
                              break;
                            }

                            return _context3.abrupt("return");

                          case 2:
                            _context3.prev = 2;
                            adapter = _this2.walletAdapters[adapterName]; // only initialize a external adapter here if it is a cached adapter.

                            if (!(_this2.cachedAdapter !== adapterName && adapter.type === ADAPTER_CATEGORY.EXTERNAL)) {
                              _context3.next = 6;
                              break;
                            }

                            return _context3.abrupt("return");

                          case 6:
                            // in-app wallets or cached wallet (being connected or already connected) are initialized first.
                            // if adapter is configured thn only initialize in app or cached adapter.
                            // external wallets are initialized on INIT_EXTERNAL_WALLET event.
                            _this2.subscribeToAdapterEvents(adapter);

                            if (!(adapter.status === ADAPTER_STATUS.NOT_READY)) {
                              _context3.next = 10;
                              break;
                            }

                            _context3.next = 10;
                            return adapter.init({
                              autoConnect: _this2.cachedAdapter === adapterName
                            });

                          case 10:
                            // note: not adding cachedWallet to modal if it is external wallet.
                            // adding it later if no in-app wallets are available.
                            if (adapter.type === ADAPTER_CATEGORY.IN_APP) {
                              _this2.initializeInAppWallet(adapterName);
                            }

                            _context3.next = 16;
                            break;

                          case 13:
                            _context3.prev = 13;
                            _context3.t0 = _context3["catch"](2);
                            log.error(_context3.t0, "error while initializing adapter");

                          case 16:
                          case "end":
                            return _context3.stop();
                        }
                      }
                    }, _callee3, null, [[2, 13]]);
                  }));

                  return function (_x4) {
                    return _ref3.apply(this, arguments);
                  };
                }());
                this.status = ADAPTER_STATUS.READY;
                _context4.next = 15;
                return Promise.all(initPromises);

              case 15:
                hasExternalWallets = allAdapters.some(function (adapterName) {
                  var _this$walletAdapters$, _this$modalConfig$ada6;

                  return ((_this$walletAdapters$ = _this2.walletAdapters[adapterName]) === null || _this$walletAdapters$ === void 0 ? void 0 : _this$walletAdapters$.type) === ADAPTER_CATEGORY.EXTERNAL && ((_this$modalConfig$ada6 = _this2.modalConfig.adapters) === null || _this$modalConfig$ada6 === void 0 ? void 0 : _this$modalConfig$ada6[adapterName].showOnModal);
                });

                if (hasExternalWallets) {
                  this.loginModal.initExternalWalletContainer();
                } // variable to check if we have any in app wallets
                // currently all default in app and external wallets can be hidden or shown based on config.


                if (!(!hasInAppWallets && hasExternalWallets)) {
                  _context4.next = 20;
                  break;
                }

                _context4.next = 20;
                return this.initExternalWalletAdapters(false, {
                  showExternalWalletsOnly: true
                });

              case 20:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, this);
      }));

      function initModal(_x2) {
        return _initModal.apply(this, arguments);
      }

      return initModal;
    }()
  }, {
    key: "connect",
    value: function () {
      var _connect = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee5() {
        var _this3 = this;

        return _regeneratorRuntime().wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                if (!this.provider) {
                  _context5.next = 2;
                  break;
                }

                return _context5.abrupt("return", this.provider);

              case 2:
                this.loginModal.open();
                return _context5.abrupt("return", new Promise(function (resolve, reject) {
                  _this3.once(ADAPTER_EVENTS.CONNECTED, function () {
                    return resolve(_this3.provider);
                  });

                  _this3.once(ADAPTER_EVENTS.ERRORED, function (err) {
                    return reject(err);
                  });
                }));

              case 4:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5, this);
      }));

      function connect() {
        return _connect.apply(this, arguments);
      }

      return connect;
    }()
  }, {
    key: "initExternalWalletAdapters",
    value: function () {
      var _initExternalWalletAdapters = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee7(externalWalletsInitialized, options) {
        var _this4 = this;

        var adaptersConfig, adaptersData, adapterPromises, adapterInitResults, finalAdaptersConfig;
        return _regeneratorRuntime().wrap(function _callee7$(_context7) {
          while (1) {
            switch (_context7.prev = _context7.next) {
              case 0:
                if (!externalWalletsInitialized) {
                  _context7.next = 2;
                  break;
                }

                return _context7.abrupt("return");

              case 2:
                adaptersConfig = {};
                adaptersData = {};
                adapterPromises = Object.keys(this.walletAdapters).map( /*#__PURE__*/function () {
                  var _ref4 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee6(adapterName) {
                    var adapter;
                    return _regeneratorRuntime().wrap(function _callee6$(_context6) {
                      while (1) {
                        switch (_context6.prev = _context6.next) {
                          case 0:
                            _context6.prev = 0;
                            adapter = _this4.walletAdapters[adapterName];

                            if (!((adapter === null || adapter === void 0 ? void 0 : adapter.type) === ADAPTER_CATEGORY.EXTERNAL)) {
                              _context6.next = 13;
                              break;
                            }

                            log.debug("init external wallet", _this4.cachedAdapter, adapterName);

                            _this4.subscribeToAdapterEvents(adapter); // we are not initializing cached adapter here as it is already being initialized in initModal before.


                            if (!(_this4.cachedAdapter === adapterName)) {
                              _context6.next = 7;
                              break;
                            }

                            return _context6.abrupt("return");

                          case 7:
                            if (!(adapter.status === ADAPTER_STATUS.NOT_READY)) {
                              _context6.next = 10;
                              break;
                            }

                            _context6.next = 10;
                            return adapter.init({
                              autoConnect: _this4.cachedAdapter === adapterName
                            });

                          case 10:
                            adaptersConfig[adapterName] = _this4.modalConfig.adapters[adapterName];
                            adaptersData[adapterName] = adapter.adapterData || {};
                            return _context6.abrupt("return", adapterName);

                          case 13:
                            _context6.next = 18;
                            break;

                          case 15:
                            _context6.prev = 15;
                            _context6.t0 = _context6["catch"](0);
                            log.error(_context6.t0, "error while initializing adapter");

                          case 18:
                          case "end":
                            return _context6.stop();
                        }
                      }
                    }, _callee6, null, [[0, 15]]);
                  }));

                  return function (_x7) {
                    return _ref4.apply(this, arguments);
                  };
                }());
                _context7.next = 7;
                return Promise.all(adapterPromises);

              case 7:
                adapterInitResults = _context7.sent;
                finalAdaptersConfig = {};
                adapterInitResults.forEach(function (result) {
                  if (result) {
                    finalAdaptersConfig[result] = adaptersConfig[result];
                  }
                });
                this.loginModal.addWalletLogins(finalAdaptersConfig, {
                  showExternalWalletsOnly: !!(options !== null && options !== void 0 && options.showExternalWalletsOnly)
                });

              case 11:
              case "end":
                return _context7.stop();
            }
          }
        }, _callee7, this);
      }));

      function initExternalWalletAdapters(_x5, _x6) {
        return _initExternalWalletAdapters.apply(this, arguments);
      }

      return initExternalWalletAdapters;
    }()
  }, {
    key: "initializeInAppWallet",
    value: function initializeInAppWallet(adapterName) {
      log.info("adapterInitResults", adapterName);

      if (this.walletAdapters[adapterName].type === ADAPTER_CATEGORY.IN_APP) {
        var _this$modalConfig$ada7, _this$options$uiConfi3;

        this.loginModal.addSocialLogins(adapterName, getAdapterSocialLogins(adapterName, this.walletAdapters[adapterName], (_this$modalConfig$ada7 = this.modalConfig.adapters[adapterName]) === null || _this$modalConfig$ada7 === void 0 ? void 0 : _this$modalConfig$ada7.loginMethods), ((_this$options$uiConfi3 = this.options.uiConfig) === null || _this$options$uiConfi3 === void 0 ? void 0 : _this$options$uiConfi3.loginMethodsOrder) || OPENLOGIN_PROVIDERS);
      }
    }
  }, {
    key: "subscribeToLoginModalEvents",
    value: function subscribeToLoginModalEvents() {
      var _this5 = this;

      this.loginModal.on(LOGIN_MODAL_EVENTS.LOGIN, /*#__PURE__*/function () {
        var _ref5 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee8(params) {
          return _regeneratorRuntime().wrap(function _callee8$(_context8) {
            while (1) {
              switch (_context8.prev = _context8.next) {
                case 0:
                  _context8.prev = 0;
                  _context8.next = 3;
                  return _this5.connectTo(params.adapter, params.loginParams);

                case 3:
                  _context8.next = 8;
                  break;

                case 5:
                  _context8.prev = 5;
                  _context8.t0 = _context8["catch"](0);
                  log.error("Error while connecting to adapter: ".concat(params.adapter), _context8.t0);

                case 8:
                case "end":
                  return _context8.stop();
              }
            }
          }, _callee8, null, [[0, 5]]);
        }));

        return function (_x8) {
          return _ref5.apply(this, arguments);
        };
      }());
      this.loginModal.on(LOGIN_MODAL_EVENTS.INIT_EXTERNAL_WALLETS, /*#__PURE__*/function () {
        var _ref6 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee9(params) {
          return _regeneratorRuntime().wrap(function _callee9$(_context9) {
            while (1) {
              switch (_context9.prev = _context9.next) {
                case 0:
                  _context9.next = 2;
                  return _this5.initExternalWalletAdapters(params.externalWalletsInitialized);

                case 2:
                case "end":
                  return _context9.stop();
              }
            }
          }, _callee9);
        }));

        return function (_x9) {
          return _ref6.apply(this, arguments);
        };
      }());
      this.loginModal.on(LOGIN_MODAL_EVENTS.DISCONNECT, /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee10() {
        return _regeneratorRuntime().wrap(function _callee10$(_context10) {
          while (1) {
            switch (_context10.prev = _context10.next) {
              case 0:
                _context10.prev = 0;
                _context10.next = 3;
                return _this5.logout();

              case 3:
                _context10.next = 8;
                break;

              case 5:
                _context10.prev = 5;
                _context10.t0 = _context10["catch"](0);
                log.error("Error while disconnecting", _context10.t0);

              case 8:
              case "end":
                return _context10.stop();
            }
          }
        }, _callee10, null, [[0, 5]]);
      })));
      this.loginModal.on(LOGIN_MODAL_EVENTS.MODAL_VISIBILITY, /*#__PURE__*/function () {
        var _ref8 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee11(visibility) {
          var _this$walletAdapters$2, walletConnectStatus;

          return _regeneratorRuntime().wrap(function _callee11$(_context11) {
            while (1) {
              switch (_context11.prev = _context11.next) {
                case 0:
                  log.debug("is login modal visible", visibility);

                  _this5.emit(LOGIN_MODAL_EVENTS.MODAL_VISIBILITY, visibility);

                  walletConnectStatus = (_this$walletAdapters$2 = _this5.walletAdapters[WALLET_ADAPTERS.WALLET_CONNECT_V1]) === null || _this$walletAdapters$2 === void 0 ? void 0 : _this$walletAdapters$2.status;

                  if (visibility && walletConnectStatus === ADAPTER_STATUS.READY) {
                    // refreshing session for wallet connect whenever modal is opened.
                    try {
                      _this5.walletAdapters[WALLET_ADAPTERS.WALLET_CONNECT_V1].connect();
                    } catch (error) {
                      log.error("Error while disconnecting to wallet connect in core", error);
                    }
                  }

                case 4:
                case "end":
                  return _context11.stop();
              }
            }
          }, _callee11);
        }));

        return function (_x10) {
          return _ref8.apply(this, arguments);
        };
      }());
    }
  }]);

  return Web3Auth;
}(Web3AuthCore);

export { Web3Auth, defaultEvmDappModalConfig, defaultEvmWalletModalConfig, defaultOtherModalConfig, defaultSolanaDappModalConfig, defaultSolanaWalletModalConfig };